/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpEncryptionKey } from '../models/GcpEncryptionKey';

export class GcpEncryptionKeys {
  'keys': Array<GcpEncryptionKey>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "keys",
      "baseName": "keys",
      "type": "Array<GcpEncryptionKey>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpEncryptionKeys.attributeTypeMap;
  }

  public constructor() {
  }
}

